import React from 'react';
import './Slide.css';
import './About.css';
import './App.css';
import {
  Facebook,
  LinkedIn,
} from "@material-ui/icons";
import {
  Link
} from "react-router-dom";
import Footer from '../store/Components/Footer';

export default class About extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <div className='aboutdes'>



        <div className="maain aboutUsPage">
          <img src="./images/home-car7.png" alt="asgfsdg" height="600px" width="400px" />
          <div className='aboutUscont'>
            <h1 className="">MechOnTrack</h1>
            <p className="">Running On The Roads Of Trust</p>
          </div>
        </div>


        <div className="aboutUsPageVision">

          <div className="aboutUsPageVisionSection">
            <h1>  MechOnTrack VISION</h1>
            <p>"To simplify vehicle repair & maintenance process and provide complete
              peace of mind to customers through continuous improvement in services
              that creates a long-term relationship between us."<br></br>
              <br></br>
              Incorporated in the year 2021, MechOnTrack thrives on its vision
              of providing the best services to customers through
              skilled mechanics. We don't believe in short-term gains,
              but in long-term relationship with our customers.
              With an ever growing team size and workshop partners,
              we intend to service each customer with utmost
              dedication so that they choose to stay with us forever.
              <br></br><br></br>
              You think of quick and easy repairs, you think of mechontrack.com</p>
          </div>

        </div>
        <div className="aboutUsPageVision">

          <div className="aboutUsPageWhoSection">
            <h1>Who We Are</h1>
            <p>"To simplify vehicle repair & maintenance process and provide complete
              peace of mind to customers through continuous improvement in services
              that creates a long-term relationship between us."<br></br>
              <br></br>
              Incorporated in the year 2021, MechOnTrack thrives on its vision
              of providing the best services to customers through
              skilled mechanics. We don't believe in short-term gains,
              but in long-term relationship with our customers.
              With an ever growing team size and workshop partners,
              we intend to service each customer with utmost
              dedication so that they choose to stay with us forever.
              <br></br><br></br>
              You think of quick and easy repairs, you think of mechontrack.com</p>
          </div>

        </div>

        <div className="carcirclesecback">
          <img src='./images/about/circle_back.jpg' alt=''></img>
          <h2>Clarity , Transparency , Community</h2>
          <div className="carcirclesec">
            <div>
              <h2>Welcome To MechOnTrack</h2>
              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
              </p>
            </div>
            <div><img src='./images/sqaure_car.jpg' alt='' /></div>
            <div>
              <div>
                <h3>Clarity</h3>
                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
              </div>
              <div>
                <h3>Transparency</h3>
                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
              </div>
            </div>
            <div>
              <h2>Deal Keeper</h2>
              <ul>
                <li><img src='./images/about/Arr.png' alt='' />Lorem Ipsum is simply dummy text of the printing</li>
                <li><img src='./images/about/Arr.png' alt='' />Lorem Ipsum is simply dummy text of the printing</li>
                <li><img src='./images/about/Arr.png' alt='' />Lorem Ipsum is simply dummy text of the printing</li>
                <li><img src='./images/about/Arr.png' alt='' />Lorem Ipsum is simply dummy text of the printing</li>
              </ul>
            </div>
            <div>
              <h3>Community</h3>
              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
            </div>
          </div>
        </div>
        <div className='ourStoryAboutUs'>
          <h2>Our Story</h2>
          <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
          <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
        </div>
        <div className="ourTeamAboutUsSec">
          <h2>Our Team</h2>
        <div className="ourTeamAboutUs">
          <div className="ourTeamAboutUsIn">
            <div className='ourTeamAboutUsInImage'>
              <img src='https://images.pexels.com/photos/1520760/pexels-photo-1520760.jpeg?auto=compress&cs=tinysrgb&w=600' alt=''></img>
            </div>
            <div className='ourTeamAboutUsInDes'>
              <h3>Name</h3>
              <h4>Title</h4>
              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
              <p className='socIco'><Link href='#' className='fb'><Facebook /></Link>
              <Link href='#' className='ln'><LinkedIn /></Link></p>
            </div>
          </div>
          <div className="ourTeamAboutUsIn">
            <div className='ourTeamAboutUsInImage'>
              <img src='https://images.pexels.com/photos/1520760/pexels-photo-1520760.jpeg?auto=compress&cs=tinysrgb&w=600' alt=''></img>
            </div>
            <div className='ourTeamAboutUsInDes'>
              <h3>Name</h3>
              <h4>Title</h4>
              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
              <p className='socIco'><Link href='#' className='fb'><Facebook /></Link>
              <Link href='#' className='ln'><LinkedIn /></Link></p>
            </div>
          </div>
          <div className="ourTeamAboutUsIn">
            <div className='ourTeamAboutUsInImage'>
              <img src='https://images.pexels.com/photos/1520760/pexels-photo-1520760.jpeg?auto=compress&cs=tinysrgb&w=600' alt=''></img>
            </div>
            <div className='ourTeamAboutUsInDes'>
              <h3>Name</h3>
              <h4>Title</h4>
              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
              <p className='socIco'><Link href='#' className='fb'><Facebook /></Link>
              <Link href='#' className='ln'><LinkedIn /></Link></p>
            </div>
          </div>
          <div className="ourTeamAboutUsIn">
            <div className='ourTeamAboutUsInImage'>
              <img src='https://images.pexels.com/photos/1520760/pexels-photo-1520760.jpeg?auto=compress&cs=tinysrgb&w=600' alt=''></img>
            </div>
            <div className='ourTeamAboutUsInDes'>
              <h3>Name</h3>
              <h4>Title</h4>
              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
              <p className='socIco'><Link href='#' className='fb'><Facebook /></Link>
              <Link href='/about' className='ln'><LinkedIn /></Link></p>
            </div>
          </div>
        </div>
        </div>
        <div className='aboutUsFounder'>
        <div className="ourTeamAboutUsIn">
            <div className='ourTeamAboutUsInImage'>
              <img src='https://images.pexels.com/photos/2531552/pexels-photo-2531552.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1' alt=''></img>
            </div>
            <div className='ourTeamAboutUsInDes'>
              <h3>Name</h3>
              <h4>Founder</h4>
              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
              <p className='socIco'><Link href='#' className='fb'><Facebook /></Link>
              <Link href='/about' className='ln'><LinkedIn /></Link></p>
            </div>
          </div>
        </div>
        <Footer />
      </div>


    )
  }
}